import React, { useState } from 'react';

export default function ClienteForm({ onSubmit, onCancel }) {
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nome.trim()) return;
    onSubmit({ nome: nome.trim(), telefone: telefone.trim() });
  };

  return (
    <form className="fm" onSubmit={handleSubmit}>
      <div className="inp-r">
        <input className="inp" placeholder="Nome *" value={nome} onChange={e => setNome(e.target.value)} required />
        <input className="inp" placeholder="Telefone" value={telefone} onChange={e => setTelefone(e.target.value)} />
      </div>
      <div className="btn-g">
        <button className="btn btn1" type="submit">Salvar</button>
        <button className="btn btn3" type="button" onClick={onCancel}>Cancelar</button>
      </div>
    </form>
  );
}
